import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErmCapabilityApiClientService, ErmSdkModule, StageInfo } from 'erm-sdk';
import { EnvironmentUiService } from '../../features/environment/services/environment-ui.service';
import { EnvironmentLaunchComponent } from '../../features/environment/environment-launch.component';
import { EnvironmentServicesComponent } from '../../features/environment/environment-services.component';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ScaleProgressEventsComponent } from '../../features/environment/components/scale-progress-events.component';
import { ErrorNormalizerService } from '../../features/environment/services/error-normalizer.service';
import { ErrorMessageComponent } from '../../features/environment/components/error-message.component';
import { environment } from '../../../../environments/environment';

@Component({
  standalone: true,
  imports: [EnvironmentServicesComponent, EnvironmentLaunchComponent, CommonModule, ErmSdkModule, MatProgressSpinnerModule, ScaleProgressEventsComponent, ErrorMessageComponent],
  selector: 'app-info',
  providers: [EnvironmentUiService],
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoComponent implements OnInit {
  public readonly environmentUiService = inject(EnvironmentUiService);
  private readonly router = inject(Router);
  public readonly isAwsStageProd = environment.stage === StageInfo.PROD;
  public isLoading: WritableSignal<boolean> = signal(false);
  public error = signal<unknown | null>(null);
  private readonly errorNormalizer = inject(ErrorNormalizerService);
  public currentEnvId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private ermCapabilityApiClient: ErmCapabilityApiClientService
  ) { }

  async ngOnInit(): Promise<void> {

    // Get route parameters
    const params = this.route.snapshot.params;
    const envId = params['envId'];
    this.currentEnvId = envId;

    await this.loadEnvironment();
  }

  public startSupportButtonClick(): void {
    this.router.navigate(['/erm/launch/support', this.environmentUiService.environment$()?.environmentId]);
  }

  private async loadEnvironment(): Promise<void> {

    if (!this.currentEnvId) {
      throw Error('Environment ID is required');
    }

    try {
      this.isLoading.set(true);
      // Get environment
      const getAppStreamEnvironmentResponse = await this.ermCapabilityApiClient.getAppStreamEnvironment(this.currentEnvId);
      const env = getAppStreamEnvironmentResponse.body?.appStreamEnvironment;
      this.environmentUiService.setEnvironment(env);
      }
    catch (error) {
      const norm = this.errorNormalizer.extract(error);
      this.error.set(norm.message);
      throw error;
    }
    finally {
      this.isLoading.set(false);
    }
  }

  public reload(): void {
    this.loadEnvironment();
  }
}
